var _excluded = ["widthSpace", "heightSpace", "type", "variant", "borderRadius"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React from "react";
import styled, { css, keyframes } from "styled-components";
import { animationDuration } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
export var defaultProps = {
  type: "slide",
  variant: "default",
  borderRadius: "round"
};
var variantValues = {
  "default": "backgroundDarkLight",
  light: "background"
};
var borderRadiusValues = {
  small: "large",
  round: "huge"
};
var slideAnimation = function slideAnimation(width) {
  return keyframes(["from{width:0;opacity:0;}to{width:", " ", ";opacity:1;}"], !!width && typeof width === "number" && css(["width:", ";"], space(width)), !!width && _typeof(width) === "object" && css(["width:", ";", "{width:", ";}", "{width:", ";}"], space(width.small), breakpoint("medium"), space(width.medium), breakpoint("large"), space(width.large)));
};
var gradientWidth = 420;
var gradientAnimation = keyframes(["from{background-position:", "}to{background-position:", "}"], unit(-1 * gradientWidth), unit(gradientWidth));
var StyledPlaceholderAtm = styled.span.withConfig({
  componentId: "sc-18le5t1-0"
})(function (_ref) {
  var $widthSpace = _ref.$widthSpace,
    $heightSpace = _ref.$heightSpace,
    $type = _ref.$type,
    $variant = _ref.$variant,
    $borderRadius = _ref.$borderRadius,
    theme = _ref.theme;
  return css(["", " ", " display:block;width:", ";height:", ";border-radius:", ";background-color:", ";", ""], !!$widthSpace && typeof $widthSpace === "number" && css(["width:", ";"], space($widthSpace)), !!$widthSpace && _typeof($widthSpace) === "object" && css(["width:", ";", "{width:", ";}", "{width:", ";}"], space($widthSpace.small), breakpoint("medium"), space($widthSpace.medium), breakpoint("large"), space($widthSpace.large)), $widthSpace, space($heightSpace), getBorderRadius(theme, borderRadiusValues[$borderRadius]), getColor(theme, variantValues[$variant]), $type === "slide" ? css(["animation:", " ", "s forwards;"], slideAnimation($widthSpace), animationDuration.slow / 1000) : css(["animation:", " 1.2s ease-in infinite;background-image:linear-gradient( 107.79deg,", " 19.55%,#cccfd0 38.83%,", " 63.83% );background-size:", ";background-repeat:no-repeat;"], gradientAnimation, getColor(theme, variantValues[$variant]), getColor(theme, variantValues[$variant]), unit(gradientWidth)));
});
function PlaceholderAtm(_ref2) {
  var widthSpace = _ref2.widthSpace,
    heightSpace = _ref2.heightSpace,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? defaultProps.type : _ref2$type,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? defaultProps.variant : _ref2$variant,
    _ref2$borderRadius = _ref2.borderRadius,
    borderRadius = _ref2$borderRadius === void 0 ? defaultProps.borderRadius : _ref2$borderRadius,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledPlaceholderAtm, _extends({
    $widthSpace: widthSpace,
    $heightSpace: heightSpace,
    $type: type,
    $variant: variant,
    $borderRadius: borderRadius
  }, restProps));
}
export default PlaceholderAtm;